import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import Crumb, { CrumbTemplateProps } from '../Crumb';

export default function ProductOverviewCrumb({ current }: CrumbTemplateProps) {
  return (
    <Crumb current={current} text={t(TranslationKey.product).plural.upper} path={Routing.stock.products.overview()} />
  );
}
